// risk-colors.ts — Endpoints couleurs de sévérité (severity 1-25 → hex).
import { req } from './_internals.js';

export const riskColorsApi = {
  getRiskColors: () => req('GET', '/risk-colors'),
  updateRiskColor: (severity: number | string, d: unknown) =>
    req('PUT', '/risk-colors/' + severity, d),
  updateRiskColorsBulk: (d: unknown) => req('PUT', '/risk-colors', d),
};
